import styled, { CSSProperties } from 'styled-components';

import { BodilColor, BodilFont, NorlysFont } from '~src/branding';

import { Chevron } from '../Chevron';

export const StepsWrapper = styled.div(() => {
  return {
    width: '100%',
    '.ant-steps-item-title': { ...BodilFont.style('default', 20) },
    '.ant-steps-item-icon': { width: '100%' },
    '.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail': {
      display: 'none',
    },
    '.ant-steps-item-content': {
      display: 'flex',
      justifyContent: 'center',
      padding: '0 16px',
    },
  };
});

export const StepsWrapperNorlys = styled.div(() => ({
  '.ant-steps-item-title': { ...NorlysFont.style('heading', 20) },
  '.ant-steps-item-icon': { width: '100%' },
  '.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail': {
    display: 'none',
  },
  '.ant-steps-item-container': { display: 'flex', flexFlow: 'column' },
  '.ant-steps-item-content': {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 24px 0 8px',
  },
  '.ant-steps-vertical > .ant-steps-item .ant-steps-item-description': { padding: 0 },
  '.ant-steps-vertical > .ant-steps-item .ant-steps-item-content': { minHeight: '18px' },
}));

export const StepAnchor = styled.div({
  position: 'absolute',
  top: '-20vh',
});

export const dividerStyle = {
  borderBottom: `2px solid ${BodilColor.greyscale[40]}`,
  marginBottom: '16px',
};

export const StepIcon = styled.div<{
  color?: string;
  textColor?: string;
  borderColor?: string;
  fontStyle?: CSSProperties;
}>(
  ({
    color = BodilColor.greyscale[40],
    textColor = 'black',
    borderColor,
    fontStyle = BodilFont.style('default', 14),
  }) => {
    return {
      height: '32px',
      width: '32px',
      ...fontStyle,
      color: textColor,
      backgroundColor: color,
      borderRadius: '16px',
      ...(borderColor && { border: `solid ${borderColor} 1px` }),
    };
  }
);

export const NavigationButtonsWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '16px',
});

export const NavigationButtonsInnerWrapper = styled.div({
  display: 'flex',
  gap: '8px',
  margin: 'auto 0 auto auto',
});

export const NavigationButtonsWrapperNorlys = styled.div({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
});

export const StyledChevron = styled(Chevron)({
  position: 'absolute',
  right: '16px',
  top: '8px',
});
